import React, { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";

export interface PlayerPhotoCaptureProps {
  onCapture: (imageSrc: string) => void;
  onBack: () => void;
  onCameraError: () => void;
}

export const PlayerPhotoCapture: React.FC<PlayerPhotoCaptureProps> = ({
  onCapture,
  onBack,
  onCameraError,
}) => {
  const webcamRef = useRef<Webcam>(null);
  const [isPortrait, setIsPortrait] = useState<boolean>(true);

  const checkOrientation = () => {
    switch (window.screen.orientation.type) {
      case "landscape-primary":
      case "landscape-secondary":
        setIsPortrait(false);
        break;
      case "portrait-secondary":
      case "portrait-primary":
        setIsPortrait(true);
        break;
      default:
        console.log("The orientation API isn't supported in this browser :(");
    }
  };

  useEffect(() => {
    try {
      window.screen.orientation.onchange = () => {
        checkOrientation();
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const videoConstraints = {
    width: { min: 640, ideal: 640, max: 768 },
    facingMode: "user",
    aspectRatio: 1.3333333333,
  };

  const portraitVideoConstraints = {
    height: { min: 640, ideal: 640, max: 768 },
    facingMode: "user",
    aspectRatio: 0.75,
  };

  const capture = useCallback(() => {
    if (webcamRef?.current === null) return;
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc === null) return;
    onCapture(imageSrc);
  }, [webcamRef, onCapture]);

  return (
    <div className="pageContainer cameraPage">
      <div className="logoContainer">
        <img src={"./img/fc-logo.svg"} width="80px" alt="Flight Club" />
      </div>

      <div className="formHeader cameraHeader">
        <div className="title">
          Game face on. <br /> Aim true.
        </div>
      </div>

      <div className="circlePhotoWrapper">
        <div className="circlePhotoContainer">
          <Webcam
            className="circleWebcam"
            videoConstraints={
              isPortrait ? portraitVideoConstraints : videoConstraints
            }
            ref={webcamRef}
            screenshotFormat={"image/jpeg"}
            mirrored={true}
            onUserMediaError={onCameraError}
          />
        </div>
        <button
          className="captureBtn"
          onClick={capture}
          aria-label="Capture photo"
        >
          <img src={"./img/capture-button.svg"} alt="Capture" />
        </button>
      </div>

      <footer className="btn-container no-margin">
        <button className="secondary small with-back-arrow" onClick={onBack}>
          <img
            className="previous-arrow"
            src="./img/previous-arrow.svg"
            alt=""
          />
          BACK
        </button>
        <button disabled className="small with-forward-arrow" onClick={capture}>
          CONFIRM
          <img className="forward-arrow" src="./img/forward-arrow.svg" alt="" />
        </button>
      </footer>
    </div>
  );
};
